export const formatTimestamp = (timestamp) => {
  return new Date(timestamp * 1000).toLocaleString();
};

export const formatDuration = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);
  if (hours > 0) return `${hours}h ${minutes}m ${secs}s`;
  if (minutes > 0) return `${minutes}m ${secs}s`;
  return `${secs}s`;
};

export const zoneColors = {
  ZoneA: "#ef4444", // red
  ZoneB: "#f59e0b", // orange
  ZoneC: "#10b981", // green
  ZoneD: "#3b82f6", // blue
  ZoneE: "#8b5cf6", // purple
  ZoneF: "#ec4899", // pink
  ZoneG: "#f97316", // amber
  ZoneH: "#0ea5e9", // sky
  ZoneI: "#22c55e", // lime
  ZoneJ: "#eab308", // yellow
  ZoneK: "#f472b6", // rose

  default: "#6b7280", // gray
};
